import { Backdrop, Box, ClickAwayListener, Modal } from '@mui/material';
import { Fade } from '@mui/material';
import { globalColors } from 'globalStyle';
import React from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowDown } from '../../assets/icons/timeSelectorArrowDown.svg';
import { ReactComponent as ArrowUp } from '../../assets/icons/timeSelectorArrowUp.svg';
import { convertHourtFrom12To24Format } from 'helpers/timelineUtils';
import { convertTo12HourFormat } from 'helpers/conversions';
import {
  getCustomTimeHourElementId,
  getCustomTimeModificatorElementId,
  getCustomTimeSelectElementId,
} from 'KonnectAnalytics/analyticsElementIds';
const TimeSelect = styled.div<{ isDisabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-color: transparent;
  height: 28px;
  width: 115px;
  padding: 8px 12px;
  background: #ffffff;
  color: ${props =>
    props.isDisabled ? globalColors.regular.text.grey : globalColors.regular.text.primary};
`;

const AMPMtogglerWrapper = styled.div<{ isDisabled: boolean }>`
  display: flex;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  cursor: pointer;
  opacity: ${props => (props.isDisabled ? 0.3 : 1)};
`;
const AmPmValue = styled.div<{ selected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  background: ${props => (props.selected ? globalColors.regular.background.blue : 'transparent')};
  color: ${props =>
    props.selected ? globalColors.regular.text.white : globalColors.regular.text.grey};
  border-radius: 4px;
`;
const TimeSelectRow = styled.div`
  margin-top: 12px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 178px;
`;
const TimeValue = styled.div``;
const ArrowWrapper = styled.div``;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  width: 115px;
  height: 365px;
  background: #ffffff;
  padding: 6px 8px;
  gap: 10px;
`;
const TimeRecordRow = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  display: flex;
  font-size: 14px;
  color: ${props =>
    props.isSelected ? globalColors.regular.text.blue : globalColors.regular.text.primary};
`;
type TimeSelectorProps = any; // TODO: Add props type

export const TIME_SELECTOR_NAMES = {
  start: 'start time',
  end: 'end time',
} as const;

const popUpStartTimeRowPositionStyle = {
  position: 'absolute' as 'absolute',
  top: 274,
  left: 629,
};
const popUpEndTimeRowPositionStyle = {
  position: 'absolute' as 'absolute',
  top: 395,
  left: 629,
};

const hoursArray = [
  { value: 0, hour: '12:00' },
  { value: 1, hour: '01:00' },
  { value: 2, hour: '02:00' },
  { value: 3, hour: '03:00' },
  { value: 4, hour: '04:00' },
  { value: 5, hour: '05:00' },
  { value: 6, hour: '06:00' },
  { value: 7, hour: '07:00' },
  { value: 8, hour: '08:00' },
  { value: 9, hour: '09:00' },
  { value: 10, hour: '10:00' },
  { value: 11, hour: '11:00' },
];

const TimeSelector = (props: TimeSelectorProps) => {
  const {
    selectorName,
    isHourSelectionDisabled,
    value,
    timeModificator,
    onHourChange,
    onTimeModificatorClickHandler,
    activeReport,
  } = props;
  const boundary = selectorName === TIME_SELECTOR_NAMES.start ? 'start' : 'end';
  const [isOpen, setIsOpen] = React.useState(false);
  const selectorTestId = getCustomTimeSelectElementId(boundary);
  const hour = convertTo12HourFormat(value).split(' ')[0];
  const onClickHandler = () => {
    if (isHourSelectionDisabled) {
      return;
    }
    setIsOpen(true);
  };
  const onAmPmClickHandler = modificator => {
    if (isHourSelectionDisabled) {
      return;
    }
    onTimeModificatorClickHandler(getCustomTimeModificatorElementId(boundary, modificator));
  };
  const onTimeRowClickHandler = (hour: number) => {
    onHourChange(hour, getCustomTimeHourElementId(boundary, hour));
    setIsOpen(false);
  };
  return (
    <>
      <ClickAwayListener onClickAway={() => setIsOpen(false)}>
        <>
          <TimeSelectRow>
            <TimeSelect
              isDisabled={isHourSelectionDisabled}
              onClick={onClickHandler}
              data-testid={selectorTestId}>
              <TimeValue>{hour}</TimeValue>
              <ArrowWrapper>
                {isOpen ? (
                  <ArrowUp
                    fill={
                      isHourSelectionDisabled
                        ? globalColors.regular.text.grey
                        : globalColors.regular.text.primary
                    }
                  />
                ) : (
                  <ArrowDown
                    fill={
                      isHourSelectionDisabled
                        ? globalColors.regular.text.grey
                        : globalColors.regular.text.primary
                    }
                  />
                )}
              </ArrowWrapper>
            </TimeSelect>
            <AMPMtogglerWrapper isDisabled={isHourSelectionDisabled}>
              <AmPmValue
                onClick={() => onAmPmClickHandler('AM')}
                selected={timeModificator === 'AM'}
                data-testid={getCustomTimeModificatorElementId(boundary, 'AM')}>
                AM
              </AmPmValue>
              <AmPmValue
                onClick={() => onAmPmClickHandler('PM')}
                selected={timeModificator === 'PM'}
                data-testid={getCustomTimeModificatorElementId(boundary, 'PM')}>
                PM
              </AmPmValue>
            </AMPMtogglerWrapper>
          </TimeSelectRow>
          <Modal
            open={isOpen}
            onClose={() => {}}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            BackdropProps={{
              timeout: 500,
              invisible: true,
            }}
            BackdropComponent={Backdrop}>
            <Fade in={isOpen}>
              <Box id="transition-modal-title">
                <ClickAwayListener onClickAway={() => setIsOpen(false)}>
                  <Wrapper
                    style={
                      selectorName === TIME_SELECTOR_NAMES.start
                        ? popUpStartTimeRowPositionStyle
                        : popUpEndTimeRowPositionStyle
                    }
                    data-testid={`${selectorTestId}-popup`}>
                    {hoursArray.map((item, index) => {
                      const isSelected = item.value === value;
                      return (
                        <TimeRecordRow
                          isSelected={isSelected}
                          key={index}
                          onClick={() => onTimeRowClickHandler(item.value)}
                          data-testid={getCustomTimeHourElementId(boundary, item.value)}>
                          {item.hour}
                        </TimeRecordRow>
                      );
                    })}
                  </Wrapper>
                </ClickAwayListener>
              </Box>
            </Fade>
          </Modal>
        </>
      </ClickAwayListener>
    </>
  );
};

export default TimeSelector;
